import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import { ISettingsApiData, IAppControlsUpdateReq, IAppControlsUpdateRes, IAppControlsGetRes } from "../../../_models/settings.model";
import { HttpParams } from "@angular/common/http";
import { IAppResponse } from "../../../_interceptors/network-error.model";

@Injectable({
  providedIn: "root",
})
export class SettingService {
  constructor(private apiService: ApiService) {}

  getAll(sortBy?: string | null, sortOrder?: string | null) {
    let params = new HttpParams({
      fromObject: {
        ...(sortBy && { sortBy: sortBy }),
        ...(sortOrder && { sortOrder: sortOrder }),
      },
    });

    return this.apiService.get<ISettingsApiData>({
      Url: "gossip/admin/subscription-plans",
      Params: params
    });
  }

  getAppControls() {
    return this.apiService.get<IAppControlsGetRes>({
      Url: "gossip/admin/settings",
    });
  }

  updateAppControls(data: IAppControlsUpdateReq) {
    return this.apiService.put<IAppControlsUpdateReq, IAppResponse>({
      Url: "gossip/admin/settings/app-controls",
      Body: data
    });
  }

  updateSubscriptionPlan(data: any) {
    return this.apiService.put<any, any>({
      Url: "gossip/admin/subscription-plans/update",
      Body: data
    });
  }
}
